import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { useOutletContext, useParams } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from '../../Context/AuthContext'
import { useUser } from '../../Context/UserContext'
import { useCommunication } from '../../Context/CommunicationContext'

export default function Chat() {

  let { id } = useParams()
  let { currentUser } = useAuth()
  let { userInfo } = useUser()
  let { getMessages } = useCommunication()

  const [msgs, setMsgs] = useState([])
  const [message, setMessage] = useState("")

  const { getChats, senderName, selectedChat } = useOutletContext()

  useEffect(() => {
    getMsgs()
  }, [id])

  //If message is unread, mark as read and update communication context
  useEffect(() => {
    if(selectedChat?.studioRead === false){
      axios.post(`${process.env.REACT_APP_API_URL}/chats/read-studio-chat`, {chatId: id})
      .then((res) => {
        getMessages()
        getChats()
      })
      .catch((e) => {
        console.log(e)
      })
    } else {
      return
    }

  }, [selectedChat])

  const getMsgs = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/chats/get-messages-by-chat-id`, {chatId: id})
    .then((res) => {
      setMsgs(res.data)
    })
    .catch((e) => {
      console.log(e)
    })
  }

  const sendMessage = () => {
    let payload ={
      chatId: id,
      message,
      timeStamp: new Date(),
      sentBy: "Studio"
    }

    if(!message){
      return
    } else {
      axios.post(`${process.env.REACT_APP_API_URL}/chats/send-studio-message`, payload)
      .then((res) => {
        getMsgs(res.data)
        getChats()
        setMessage("")
      })
      .catch((e) => {
        console.log(e)
      })
    }
  }
  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    scrollToBottom()
  }, [msgs]);


  return (
    <div >
      <div style={{overflow:'scroll', height: 'calc(85vh - 100px)'}}>
        {msgs.map((msg, i) => {
          let split = msg.message?.split('\n')

            return (
              <div style={{ width: '100%', minHeight: 100, margin: '1rem 0', display:'flex', alignItems:'center', justifyContent: msg.sentBy !== "Studio" ? "left" : "right"  }} key={i}>
                {msg.sentBy === "Studio" && 
                (
                  userInfo?.logo ?
                    <div className='msg-avatar' style={{backgroundImage: `url(${userInfo.logo})`, backgroundSize:'cover', backgroundPosition:'center'}}>
                    </div>
                    :
                    <div className='msg-avatar-sml'>{senderName.split(" ")[0].charAt(0)}{senderName.split(" ")[1].charAt(0)}</div>
                )
                }

                <div  className={msg.sentBy !== "Studio" ? 'other-sender-msg' : 'my-msg'} >
                  {split.map((line, i) => {
                    return <p key={i} style={{width: '100%',minHeight: 15, border: 'unset', resize: 'none', fontSize: 16, height: 'auto'}}>{line}</p>

                  })}
                  <p style={{color: 'grey', fontSize: '0.8rem', marginTop: 10}}>{moment(msg.timeStamp).format('Do MMM YY, hh:mm a')}</p>
                </div>
              </div>
            )
          })}
          <div ref={messagesEndRef}/>
      </div>
        

    

      <div id='msg-box'>
        {userInfo?.logo ? <img className='msg-avatar-sml' src={userInfo?.logo}/>
        :
        <div className='msg-avatar-sml'>
          <p>{currentUser.displayName.charAt(0)}</p>
        </div>
      }
        <textarea  placeholder='Type your message' className='om-input' style={{width: '80%', marginRight: 10, resize:'none', paddingTop: 10}} value={message} onChange={(e) => setMessage(e.target.value)}/>

        <button className='sml-btn' onClick={sendMessage}>Send</button>
      </div>
      
    </div>
  )
}
